module.exports = __webpack_public_path__ + "img/arrow-down-circle-fill.2ca0b941.svg";